import Component from './DealsForm.container';

export default Component;
